import {HeadersAbstract} from "@bunt/app";

export class Headers extends HeadersAbstract {

}
